/*
 * @Author: 朱亚
 * @Date: 2020-10-10 10:19:09
 * @说明：声明数据请求插件$fetch
 */
import bind from './bind'
const install = Vue => {
  if (install.installed) return
  install.installed = true
  Object.defineProperty(Vue.prototype, '$fetch', {
    get() {
      return bind
    }
  })
}
export default install



// WEBPACK FOOTER //
// ./src/api/index.js